<ng-template [ngIf]="media && !isLoading" [ngIfThen]="list"></ng-template>
<ng-template [ngIf]="!media && !isLoading" [ngIfThen]="emptyList"></ng-template>
<ng-template [ngIf]="!media && isLoading" [ngIfThen]="loading"></ng-template>

<sn-fab-button
  *ngIf="canAdd"
  [matTooltip]="'common.addMedia' | t"
  matTooltipPosition="after"
  position="bottomRight"
  (click)="add()"
>
  <sn-icon>add</sn-icon>
</sn-fab-button>

<ng-template #list>
  <sn-incident-media-list [media]="media" (fileDeleted)="deleteItem($event)">
  </sn-incident-media-list>
</ng-template>

<ng-template #emptyList>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
    {{ 'common.noMediaFound' | t }}
  </sn-empty-state>
</ng-template>

<ng-template #loading>
  <mat-spinner [diameter]="48" [strokeWidth]="4" color="accent"></mat-spinner>
</ng-template>
